import 'utils/toastr';

import './index.scss';
import 'utils/prevent_parent_scroll';

// Mixins
import Cache from './lib/cache';
import Fetch from './lib/fetch';
import Render from './lib/render';
import Search from './lib/search';
import Pagination from './lib/pagination';
import Utils from './lib/utils';
import Externals from './lib/externals';

// TODO: Document qselect actions and events
class Select {
  constructor(el) {
    if (!el || el.qselectInstance) return;

    // General
    this.$component = $(el);
    this.bindSearch();
    this.loadConfig();
    this.options = [];
    this.reset(false);

    // Handle selected for single input
    if (!this.multiple) {
      const $selected = $('input:checked', this.$component);

      if ($selected.length)
        this.select($selected.parents('li'));
    }

    // Events
    this._bindDropdownEvents();
    this._bindChangeEvents();
    this._bindSearchEvents();
    this._bindKeyboardEvents();

    if (!this.ajax) {
      this.mapRenderedOptions();
      return;
    }

    // Ajax
    this._bindScrollEvents();
  }

  _bindDropdownEvents() {
    const self = this;

    if (MediaQuery.is('xs'))
      $('.dropdown-menu', this.$component).addClass('dropdown-menu-keepopen');

    $('.dropdown-menu', this.$component)
      .on('keydown', function (e) {
        if (self.isMobile) return;

        const $el = $(this);
        const $focused = $('li:focus', $el).not('.q-search-input');

        if (e.keyCode === 13) {
          const $input = $('input', $focused);
          $input.prop('checked', !$input.is(':checked')).change();

          if (!self.multiple)
            self.select($focused);
        }
      })
      .on('click', function (e) {
        self.multiple && self.$component.is('.open') && e.stopPropagation();
      })
      .on('click', '.js-close-select-dropdown-btn', function () {
        self.close();
      });

    this.$component
      .on('show.bs.dropdown', function () {
        if (MediaQuery.is('xs'))
          $('body').addClass('q-select-no-scroll');
      })
      .on('hide.bs.dropdown', function () {
        if (MediaQuery.is('xs'))
          $('body').removeClass('q-select-no-scroll');
      });
  }

  checkLimits(input) {
    const self = this;

    const $namePlaceholder = $('.q-placeholder', self.$component).text().toLowerCase();
    const checkedCount = self.getSelectedCount();
    const index = self.selectedValues.indexOf(input.value);

    if (checkedCount > self.config.limit && self.config.limit > 0) {
      input.checked = false;
      self.selectedValues.splice(index, 1);
      self.updateCounter(self.config.limit);
      toastr.warning('Ops! Selecione até ' + self.config.limit + ' itens do filtro de ' + $namePlaceholder + '!');
    } else {
      self.updateCounter(checkedCount);
    }
  }

  _bindChangeEvents() {
    const self = this;

    $(self.$component)
      .on('change', 'input[type="checkbox"], input[type="radio"]', function () {
        const $parent = $(this).parents('li');
        const $input = $(this);
        const value = $input.val().toString();
        const i = self.selectedValues.indexOf(value);

        if (self.multiple) {
          if ($input.is(':checked') && i < 0) {
            self.selectedValues.push(value);
          } else if (!$input.is(':checked') && i > -1) {
            self.selectedValues.splice(i, 1);
          }

          self._execCallbacks('change', self.selectedValues);
        } else {
          self.config.value = value;
          self._execCallbacks('change', value);
        }

        if (self.multiple) {
          self.checkLimits(this);
        } else {
          self.select($parent);
        }
      });
  }

  _bindKeyboardEvents() {
    const self = this;

    this.$component.on('keydown', function (e) {
      if (this.isMobile) return;

      const $focused = $('li:visible:focus', self.$component).not('.q-search-input');

      if (e.keyCode === 38 || e.keyCode === 40) {
        e.preventDefault();

        if ($focused.length === 0) {
          $('li:visible', self.$component).not('.q-search-input').first().focus();
        } else if (e.keyCode === 40) {
          $focused.nextAll('li:visible').not('.q-search-input').first().focus();
        } else if (e.keyCode === 38) {
          const $prev = $focused.prevAll('li:visible').not('.q-search-input');
          if ($prev.length) {
            $focused.prevAll('li:visible').not('.q-search-input').first().focus();
          } else {
            if (self.isMobile) return;
            self.$component.find('.q-search-input input').focus();
          }
        }
      }
    }).on('show.bs.dropdown', function () {
      if (self.ajax && !self.isDataFetched) {
        self.fetch();
      }

      if (self.isMobile) return;
      setTimeout(() => $(this).find('.q-search-input input').focus(), 200);
    });
  }

  _bindScrollEvents() {
    const self = this;

    $('.dropdown-menu .q-options', this.$component)
      .on('scroll', function () {
        if (Math.ceil($(this).scrollTop() + $(this).innerHeight()) >= $(this)[0].scrollHeight) {
          const nextPage = self._getNextPage();

          if (!nextPage) return;

          const data = nextPage.data;
          self.renderOptions(data, false, false);
        }
      }).preventParentScroll();
  }

  mapRenderedOptions() {
    if (!this.config.textField || !this.config.valueField) return;

    this.selectedValues = [];

    const options = $('.q-options input', this.$component)
      .map((i, input) => {
        const $input = $(input);
        const ret = {};
        ret[this.config.textField] = $input.next('span').text();
        ret[this.config.valueField] = $input.val();

        if (this.multiple && input.checked)
          this.selectedValues.push($input.val().toString());

        return ret;
      })
      .toArray();

    this.options = options;

    if (this.multiple)
      this.updateCounter();
    else
      this.updateSelected();
  }

  loadConfig() {
    this.config = this.$component.data();
    this.enableCache = this.config.cache && !!window.sessionStorage && this.config.ajaxUrl;
    this.ajax = this.config.ajax;
    this.ajaxUrl = this.config.ajaxUrl;
    this.thor = this.config.thor;
    this.multiple = this.config.multiple;
    this.name = this.config.name;
    this.placeholder = this.config.placeholder;
    this.hidePlaceholderWhenSelect = this.config.hidePlaceholderWhenSelect;
    this.isMobile = MediaQuery.is('lt_md');

    this.configureCache();
    this.configureFetch();
  }

  static getValidActions() {
    return [
      'fetch',
      'close',
      'enable',
      'disable',
      'refresh',
      'reset',
      'getValue',
      'setValue',
      'getOptions',
      'setOptions',
      'getConfig',
      'setConfig',
      'setFormatFunction',
      'setOptionRenderingFunction',
      'clearCache',
      'on'
    ];
  }

  static handleActions($el, action, args) {
    if (!action) return $el;
    const validActions = Select.getValidActions();
    if (validActions.indexOf(action) < 0) throw new Error(`"${action}" is not a valid action.`);

    if (action.indexOf('get') > -1) {
      const el = $el.get(0);
      return el && $el.get(0).qselectInstance[action](...args);
    } else {
      $el.each((i, el) => {
        el.qselectInstance[action](...args);
      });
      return $el;
    }
  }
}

Select.prototype = Object.assign(
  Select.prototype,
  Cache,
  Fetch,
  Render,
  Search,
  Pagination,
  Utils,
  Externals
);

(function ($) {
  'use strict';

  // Defining jQuery plugin
  if (!$.fn.qselect) {
    $.fn.qselect = function (action) {
      const $el = this;
      const args = $.makeArray(arguments);
      args.shift();

      $el.each((i, el) => !el.qselectInstance && (el.qselectInstance = new Select(el)));
      return Select.handleActions($el, action, args);
    };
  }

  // Applying to existing .q-select-input
  $('.q-select-input').each((i, el) => {
    $(el).qselect();
  });
})(jQuery);
